'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _PubNubPresenceActions = require('conversations-core/actions/PubNubPresenceActions');

var _PubNubPresenceEventTypes = require('conversations-core/constants/PubNubPresenceEventTypes');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _strings = require('conversations-core/constants/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTypingTimeout = 3000;

function isNewChannel(action, currentChannel) {
  return action.type === _ActionTypes2.default.SET_CURRENT_CHANNEL && action.payload.channel !== currentChannel;
}

exports.default = function (isAdmin) {
  return function (store) {
    var currentRole = isAdmin ? _RoleTypes2.default.REP : _RoleTypes2.default.VISITOR;
    var lastPresenceTimestamp = void 0;
    var typingTimeout = void 0;

    function shouldUpdateState(newPresence) {
      var state = newPresence.state;

      if (!state) {
        return false;
      }

      var newTimestamp = parseInt(newPresence.state.timestamp, 10);

      var isNewestData = !lastPresenceTimestamp || lastPresenceTimestamp < newTimestamp;

      if (isNewestData) {
        lastPresenceTimestamp = newTimestamp;
      }

      return isNewestData;
    }

    function sentMessage(action) {
      if (action.type !== _ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE) {
        return false;
      }

      var message = (0, _getIn2.default)(['meta', _strings.PUBNUB_KEY, 'message'], action);
      if ((0, _ConversationalMessageModel.isChatMessage)(message)) {
        return false;
      }

      return true;
    }

    function getNewTypingState(isTyping) {
      var storeState = store.getState();
      var whosTyping = storeState.typing.get('whosTyping');

      if (isTyping) {
        return whosTyping.add(currentRole);
      }

      return whosTyping.delete(currentRole);
    }

    function resetTypingListener() {
      var newState = getNewTypingState(false);
      store.dispatch((0, _PubNubPresenceActions.sendTypingState)(newState));
      if (typingTimeout) {
        clearTimeout(typingTimeout);
        typingTimeout = null;
      }
    }

    function recievedTyping() {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      } else {
        store.dispatch((0, _PubNubPresenceActions.sendTypingState)(getNewTypingState(true)));
      }
      typingTimeout = setTimeout(function () {
        resetTypingListener();
      }, isTypingTimeout);
    }

    function shouldResetForTimeout(presence, currentChannel) {
      return presence.action === _PubNubPresenceEventTypes.LEAVE_EVENT || presence.action === _PubNubPresenceEventTypes.TIMEOUT_EVENT && presence.channel === currentChannel;
    }

    return function (next) {
      return function (action) {
        var _store$getState = store.getState(),
            currentChannel = _store$getState.currentChannel;

        if (action.type === _ActionTypes2.default.RECEIVED_PUBNUB_PRESENCE) {
          var presence = action.payload;

          if (presence.action === _PubNubPresenceEventTypes.STATE_CHANGE && presence.channel === currentChannel && shouldUpdateState(presence)) {
            var whosTyping = presence.state.whosTyping;
            store.dispatch((0, _PubNubPresenceActions.receivedTypingState)(whosTyping, isAdmin));
          }

          if (shouldResetForTimeout(presence, currentChannel)) {
            store.dispatch((0, _PubNubPresenceActions.receivedTypingState)([], isAdmin));
          }
        }

        if (isNewChannel(action, currentChannel)) {
          resetTypingListener();
          store.dispatch((0, _PubNubPresenceActions.setShowTypingIndicator)(false));
        }

        if (sentMessage(action)) {
          resetTypingListener();
        }

        if (action.type === _ActionTypes2.default.CHAT_INPUT_CHANGED) {
          recievedTyping();
        }
        return next(action);
      };
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/middleware/TypingMiddleware.js
// module id = 489
// module chunks = 0